import styled from 'styled-components'

export const DetailRoot = styled.article`
    max-width: 960px;
    animation: researchDetailReveal 0.36s ease both;
    @keyframes researchDetailReveal { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: none; } }
    @media (prefers-reduced-motion: reduce) { animation: none; }
`;
export const BackButton = styled.button`
    margin: 0 0 34px;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.palette.colors.muted};
    font-family: Lato, sans-serif;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    &:hover { color: ${({ theme }) => theme.palette.blue.main}; }
    &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 5px; }
`;
export const DetailHeader = styled.header`
    padding-bottom: 34px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderStrong};
`;
export const SourceBadge = styled.div`
    margin-bottom: 12px;
    color: ${({ theme }) => theme.palette.blue.main};
    font-family: Poppins, sans-serif;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.14em;
    text-transform: uppercase;
`;
export const DetailTitle = styled.h2`
    max-width: 900px;
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Gilroy, sans-serif;
    font-size: clamp(30px, 4.2vw, 48px);
    font-weight: 700;
    letter-spacing: -0.035em;
    line-height: 1.12;
`;
export const Facts = styled.div`
    margin: 0;
    padding: 28px 0;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
    @media (max-width: 760px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    @media (max-width: 440px) { grid-template-columns: 1fr; }
`;
export const Fact = styled.div`
    margin: 0 0 20px;
    &:last-child { margin-bottom: 0; }
`;
export const FactLabel = styled.div`
    margin-bottom: 6px;
    color: ${({ theme }) => theme.palette.colors.subdued};
    font-family: Lato, sans-serif;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
`;
export const FactValue = styled.div`
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Lato, sans-serif;
    font-size: 14px;
    line-height: 1.55;
`;
export const Conditions = styled.div`
    margin: 0;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Lato, sans-serif;
    font-size: 14px;
    line-height: 1.55;
    text-transform: capitalize;
`;
export const Section = styled.section`
    padding: 34px 0;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
`;
export const SectionTitle = styled.h3`
    margin: 0 0 24px;
    color: ${({ theme }) => theme.palette.colors.text};
    font-family: Gilroy, sans-serif;
    font-size: 23px;
    font-weight: 700;
`;
export const Metrics = styled.div`
    margin-top: 24px;
    display: flex;
    gap: 42px;
`;
export const Metric = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    strong { color: ${({ theme }) => theme.palette.colors.text}; font-family: Gilroy, sans-serif; font-size: 31px; }
    span { color: ${({ theme }) => theme.palette.colors.muted}; font-family: Lato, sans-serif; font-size: 12px; }
`;
export const ExternalLink = styled.a`
    color: ${({ theme }) => theme.palette.blue.main};
    font-family: Lato, sans-serif;
    font-size: 14px;
    font-weight: 800;
    text-decoration: none;
    &:hover { text-decoration: underline; }
    &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 5px; }
`;
